export default __webpack_public_path__ + "static/media/download_pdf.b3542253.svg";